import { Country } from '@/helpers/conf';

export enum Locale {
  ENGLISH = 'en',
  ENGLISH_CANADA = 'en-CA',
  ENGLISH_AUSTRALIA = 'en-AU',
  ENGLISH_IRELAND = 'en-IE',
  ENGLISH_NEW_ZEALAND = 'en-NZ',
  GERMAN = 'de',
  FRENCH_CANADA = 'fr-CA',
  FRENCH_SWITZERLAND = 'fr-CH',
  NORWEGIAN = 'no',
  ESTONIA = 'et-EE',
  FINLAND = 'fi',
}

export const isFrenchLocale = (locale: string): boolean => {
  return [Locale.FRENCH_CANADA, Locale.FRENCH_SWITZERLAND].includes(
    locale as Locale
  );
};

export const LocaleToISO: Record<string, string> = {
  [Locale.ESTONIA]: 'et',
  [Locale.FRENCH_CANADA]: 'fr',
  [Locale.GERMAN]: 'de',
};

type Languages = {
  [codeCountry: string]: {
    locale: Locale;
    countryIcon: string;
    subName?: string;
  }[];
};

export const languages: Languages = {
  [Country.UnitedKingdom]: [
    {
      locale: Locale.ENGLISH,
      countryIcon: 'en',
      subName: 'en',
    },
  ],
  [Country.Germany]: [
    {
      locale: Locale.GERMAN,
      countryIcon: 'de',
    },
  ],
  [Country.Canada]: [
    {
      locale: Locale.ENGLISH_CANADA,
      countryIcon: 'en-CA',
    },
    {
      locale: Locale.FRENCH_CANADA,
      countryIcon: 'fr-CA',
      subName: 'fr-CA',
    },
  ],
  [Country.Switzerland]: [
    {
      locale: Locale.GERMAN,
      countryIcon: 'de',
    },
    {
      locale: Locale.FRENCH_SWITZERLAND,
      countryIcon: 'fr-CH',
      subName: 'fr-CH',
    },
  ],
  [Country.Norway]: [
    {
      locale: Locale.NORWEGIAN,
      countryIcon: 'no',
      subName: 'no',
    },
  ],
  [Country.Australia]: [
    {
      locale: Locale.ENGLISH_AUSTRALIA,
      countryIcon: 'en-AU',
    },
  ],
  [Country.Ireland]: [
    {
      locale: Locale.ENGLISH_IRELAND,
      countryIcon: 'en-IE',
    },
  ],
  [Country.NewZealand]: [
    {
      locale: Locale.ENGLISH_NEW_ZEALAND,
      countryIcon: 'en-NZ',
    },
  ],
  [Country.Estonia]: [
    {
      locale: Locale.ESTONIA,
      countryIcon: 'et',
    },
  ],
  [Country.Finland]: [
    {
      locale: Locale.FINLAND,
      countryIcon: 'fi',
    },
  ],
};

export const countryTitle: Record<Locale, string> = {
  [Locale.ENGLISH_AUSTRALIA]: 'Australia',
  [Locale.ENGLISH]: 'England',
  [Locale.ENGLISH_CANADA]: 'Canada',
  [Locale.GERMAN]: 'Deutschland',
  [Locale.ENGLISH_IRELAND]: 'Ireland',
  [Locale.ENGLISH_NEW_ZEALAND]: 'New Zealand',
  [Locale.FRENCH_CANADA]: 'Canada',
  [Locale.FRENCH_SWITZERLAND]: 'Switzerland',
  [Locale.NORWEGIAN]: 'Norway',
  [Locale.ESTONIA]: 'Estonia',
  [Locale.FINLAND]: 'Finlad',
};

export const localStringLocalesMap: Record<string, string> = {
  [Locale.GERMAN]: 'de-AT',
  [Locale.FRENCH_CANADA]: 'en',
};
